import { useId } from 'react';

import { unitMapping, type Unit } from '#src/lib/style.ts';

export const SocialActivity = ({ size = 3 }: { size?: Unit }) => {
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M1 10.4375C1 11.3229 1 12.2083 1 13.0938C1.68742 13.0901 2.37485 13.0865 3.06227 13.0828C3.91651 13.0783 4.77076 13.0738 5.625 13.0692L6.68263 12.5277C8.29567 10.2639 9.90871 8.00005 11.5218 5.73623L9.26109 5.22608C10.199 10.216 11.137 15.206 12.0749 20.196L14.1946 20.6678C15.8798 18.2734 17.5651 15.879 19.2504 13.4846L18.3281 13.9601C19.0626 13.9562 19.797 13.9523 20.5315 13.9484C21.2189 13.9448 21.9063 13.9411 22.5938 13.9375C22.5938 13.1979 22.5938 12.4583 22.5938 11.7188C21.9063 11.7151 21.2189 11.7115 20.5315 11.7078C19.797 11.7039 19.0626 11.7 18.3281 11.6961L17.4059 12.1717C15.6953 14.5481 13.9848 16.9245 12.2742 19.3009L14.3938 19.7728C13.5088 14.7732 12.6239 9.77355 11.7389 4.77392L9.47825 4.26377C7.84129 6.51036 6.20433 8.75695 4.56737 11.0035L5.625 10.462C4.77076 10.4575 3.91651 10.453 3.06227 10.4484C2.37485 10.4448 1.68742 10.4411 1 10.4375Z"
        fill={`url(#${id})`}
      />
      <defs>
        <linearGradient
          id={id}
          x1="11.7969"
          y1="5"
          x2="11.7969"
          y2="19.9844"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9A45FF" />
          <stop offset="1" stopColor="#03FFBD" />
        </linearGradient>
      </defs>
    </svg>
  );
};
